import { PolicyType } from '@practium/features/policy';
import { useQuery } from '@tanstack/react-query';
import api from '../../http';
import { toApiError } from '../utils';

export interface PolicyVersionResponse {
	_id: string;
	versionNumber: string;
	__v: number;
	content: string;
	effectiveDate: string;
	isActive: boolean;
	policyType: PolicyType;
	title?: string;
	description?: string;
	updatedAt: string;
}

export function useGetManagementePolicyVersion() {
	const query = useQuery<PolicyVersionResponse[]>({
		queryKey: ['policies', 'management'],
		queryFn: async () => {
			try {
				const response = await api.get<PolicyVersionResponse[]>('/management/policy-version/findAll');
				return response.data;
			} catch (error) {
				throw toApiError(error, 'Erro ao buscar políticas');
			}
		},
	});

	return {
		...query,
	};
}
